import rsLogo from '../../../micro-master/public/rs-logo.png'
import scLogo from '../../../micro-master/public/sc-logo.png'
import rsFavicon from '../../../micro-master/public/favicon-rs.png'
import scFavicon from '../../../micro-master/public/favicon-sc.png'
import defaultLogo from '../../../micro-master/public/logo.svg'
import defaultFavicon from '../../../micro-master/public/favicon.ico'

export interface CompanyConfig {
  /** 公司名称 */
  name: string
  /** 公司简称 */
  shortName: string
  /** 备案号 */
  beian: string
  /** Logo 路径 */
  logo: string
  /** Favicon 路径 */
  favicon: string
}

/**
 * 非盛付通公司配置映射
 * key: URL 标识（用于匹配）
 * value: 公司配置信息
 */
const COMPANY_CONFIG_MAP: Record<string, CompanyConfig> = {
  'timeget': {
    name: '海南掌门容时数码科技有限公司',
    shortName: '掌门容时',
    logo: rsLogo,
    favicon: rsFavicon,
    beian: '琼ICP备2023004586号-1',
  },
  'qieke': {
    name: '上海盛畅网络科技有限公司',
    shortName: '盛畅',
    logo: scLogo,
    favicon: scFavicon,
    beian: '沪ICP备10031417号-6',
  },
  'default': {
    name: '海南掌门容时数码科技有限公司',
    shortName: '掌门容时',
    logo: rsLogo,
    favicon: rsFavicon,
    beian: '琼ICP备2023004586号-1',
  },
}

const COMPANY_LIST = [...Object.keys(COMPANY_CONFIG_MAP)]
// 本地开发环境, 可以打开注释
// COMPANY_LIST.push('localhost')

/**
 * 根据 URL 匹配公司配置
 * 匹配规则：检查 URL 中是否包含配置的 key（不区分大小写）
 */
function matchCompanyConfig(): CompanyConfig {
  const url = window.location.href.toLowerCase()
  
  // 遍历配置映射，查找匹配的公司
  for (const [key, config] of Object.entries(COMPANY_CONFIG_MAP)) {
    if (key === 'default') continue // 跳过默认配置
    
    // 如果 URL 中包含配置的 key，则匹配成功
    if (url.includes(key.toLowerCase())) {
      return config
    }
  }
  
  // 如果没有匹配到，返回默认配置
  return COMPANY_CONFIG_MAP.default
}

export function useIsSp() {
  const isSp = !COMPANY_LIST.some(item => window.location.href.includes(item))
  
  if (isSp) {
    return {
      company: '盛付通',
      name: '上海盛付通电子支付服务有限公司',
      shortName: '盛付通',
      isNotSp: false,
      logo: defaultLogo,
      favicon: defaultFavicon,
      beian: '沪ICP备08024653号-10',
    }
  }
  
  // 非盛付通，从配置映射中获取公司信息
  const companyConfig = matchCompanyConfig()
  
  return {
    company: companyConfig?.shortName,
    name: companyConfig?.name,
    shortName: companyConfig?.shortName,
    isNotSp: true,
    logo: companyConfig?.logo,
    favicon: companyConfig?.favicon,
    beian: companyConfig?.beian,
  }
}
